import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getFollowUp = async (params) => {
  const data = await apiCall("get", apiEndPoints.GETFOLLOWUP, params);
  return data;
};
const followupList = async (params) => {
  const data = await apiCall("post", apiEndPoints.FOLLOWUPLIST, params);
  return data;
};
const getFollowupDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETFOLLOWUPDETAIL, params);
  return data;
};
const updateFollowUp = async (params) => {
  const data = await apiCall("post", apiEndPoints.UPDATEFOLLOWUP, params);
  return data;
};
const updateStatus = async (params) => {
  const data = await apiCall("post", apiEndPoints.UPDATESTATUS, params);
  if (data.data.status == 200) {
    return data;
  } else {
    return [];
  }
};
const addFollowUp = async (params) => {
  const data = await apiCall("post", apiEndPoints.ADDFOLLOWUP, params);
  return data;
};
const getScheduledFollowupList = async (params) => {
  const data = await apiCall("post", apiEndPoints.SCHEDULEDFOLLOWUPLIST, params);
  return data;
};
const getMarkScheduledFollowup = async (params) => {
  const data = await apiCall("post", apiEndPoints.MARKSCHEDULEDFOLLOWUP, params);
  return data;
};

const followUpService = {
  getFollowUp,
  followupList,
  getFollowupDetail,
  updateFollowUp,
  updateStatus,
  addFollowUp,
  getScheduledFollowupList,
  getMarkScheduledFollowup
};

export default followUpService;
